// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "daily-kos-beta." + "data_hub_web_analytics" + "." + "739a85a3e806695164f4" + ".js";
};